import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';

import { BackDropLoad } from './LoadingBackDrop';
import { Loading } from './Loading';
import { UserContext, SnackbarContext } from './userContext';
import {
  AccountHeader,
  FormCard,
  Field,
  SelectField,
  ToggleSwitch,
  PrimaryButton,
  Icon,
} from './myacc/primitives';

export const MyAccUpgradeProfile = () => {
  const history = useNavigate();

  const [loading, setLoading] = useState(true);

  const [cats, setCats] = useState();
  const [subcats, setSubcats] = useState();

  const [cat, setCat] = useState('0');
  const [subcat, setSubcat] = useState('0');

  const [supname, setSupname] = useState('');
  const [email, setEmail] = useState('');

  const [exp, setExp] = useState('');
  const [qual, setQual] = useState('');
  const [courses, setCourses] = useState('');
  const [showhide, setShowhide] = useState('1');

  const [error, setError] = useState(0);
  const [wait, setWait] = useState(false);

  const { user, setUser } = useContext(UserContext);
  const { setSnack } = useContext(SnackbarContext);

  useEffect(() => {
    if (user.user_email !== null) setEmail(user.user_email);
    Axios.post('/new_apis/getupgradedata', { role: user.user_role }, { headers: { tkn: user.token } }).then((res) => {
      if (res.data.status === 1) {
        setCats(res.data.cats);
        setSubcats(res.data.subcats);
        setLoading(false);
      } else if (res.data.status === 3) {
        history('/');
        setSnack({ message: res.data.msg, type: 'error', open: true, direction: 'left' });
      } else if (res.data.status === 4) {
        setUser(null);
        history('/');
        localStorage.removeItem('estkn');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
      }
    });
  }, []); // eslint-disable-line

  const updatedetails = (e) => {
    e.preventDefault();
    setError(0);
    if (cat === '0') {
      setError(1);
      setSnack({ message: 'Please select a category.', type: 'error', open: true, direction: 'center' });
      return;
    }
    if (cat !== '6' && cat !== '7' && supname === '') {
      setSnack({ message: 'Please enter the registered supplier / service provider name.', type: 'error', open: true, direction: 'center' });
      setError(2);
      return;
    }
    if (cat !== '6' && cat !== '7' && !email.includes('@')) {
      setSnack({ message: 'Please enter a valid email ID.', type: 'error', open: true, direction: 'center' });
      setError(3);
      return;
    }
    if ((cat === '6' || cat === '7') && subcat === '0') {
      setSnack({ message: 'Please select a sub-category.', type: 'error', open: true, direction: 'center' });
      setError(4);
      return;
    }

    const formData = {
      supname,
      email,
      uid: user.user_id,
      role: user.user_role,
      cat,
      subcat,
      qual,
      exp,
      courses,
      showhide,
    };
    setWait(true);
    Axios.post('/new_apis/upgradeprofile', formData, { headers: { tkn: user.token } }).then((res) => {
      if (res.data.status === 1) {
        if (res.data.cat === '6' || res.data.cat === '7') {
          setUser((prev) => ({ ...prev, category_ids: res.data.cat, cat_name: res.data.catname, user_role: '2' }));
        } else {
          setUser((prev) => ({ ...prev, category_ids: res.data.cat, cat_name: res.data.catname, user_email: res.data.email, user_role: '2' }));
        }
        setSnack({ message: res.data.msg, type: 'success', open: true, direction: 'center' });
        history('/myaccount/profile');
        setWait(false);
      } else if (res.data.status === 3) {
        setWait(false);
        history('/');
        setSnack({ message: res.data.msg, type: 'error', open: true, direction: 'center' });
      } else if (res.data.status === 4) {
        setUser(null);
        setWait(false);
        localStorage.removeItem('estkn');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
        history('/');
      }
    });
  };

  if (loading) return <Loading />;

  const showSupName = cat !== '7' && cat !== '6' && cat !== '0';
  const showSubcat = cat === '7' || cat === '6';
  const showEmail = cat !== '7' && cat !== '6';

  return (
    <>
      <BackDropLoad wait={wait} />
      <AccountHeader
        kicker="Account"
        title="Upgrade profile"
        subtitle="Become a service provider and list your offerings on ESAY."
      />

      <FormCard onSubmit={updatedetails}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <SelectField
            label="Category"
            value={cat}
            onChange={(e) => { setCat(e.target.value); setSubcat('0'); }}
            error={error === 1}
            errorMsg="Please choose a category."
            required
          >
            <option value="0">Please select a category</option>
            {cats && cats.map((c) => (
              <option key={c.category_id} value={c.category_id}>{c.category_name}</option>
            ))}
          </SelectField>

          {showSubcat && (
            <SelectField
              label="Sub-category"
              value={subcat}
              onChange={(e) => setSubcat(e.target.value)}
              error={error === 4}
              errorMsg="Please choose a sub-category."
              required
            >
              <option value="0">Please select a sub-category</option>
              {subcats && subcats.map((sc) => (cat === sc.category_ids ? (
                <option key={sc.sub_category_id} value={sc.sub_category_id}>{sc.sub_category_name}</option>
              ) : null))}
            </SelectField>
          )}

          {showSupName && (
            <Field
              label="Service provider / supplier name"
              value={supname}
              onChange={(e) => setSupname(e.target.value)}
              error={error === 2}
              errorMsg="Please enter a name."
              required
            />
          )}

          {showEmail && (
            <Field
              label="Email ID"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={error === 3}
              errorMsg="Please enter a valid email ID."
              required
              icon={<Icon.Mail className="h-4 w-4" />}
            />
          )}

          {cat === '7' && (
            <Field
              label="Experience in years"
              value={exp}
              onChange={(e) => setExp(e.target.value)}
            />
          )}

          {cat === '7' && (
            <Field
              label="Qualification"
              value={qual}
              onChange={(e) => setQual(e.target.value)}
            />
          )}

          {cat === '6' && (
            <Field
              label="Courses"
              value={courses}
              onChange={(e) => setCourses(e.target.value)}
            />
          )}

          {(cat === '7' || cat === '6') && (
            <ToggleSwitch
              label="Profile visibility"
              checked={showhide === '1'}
              onChange={() => setShowhide(showhide === '1' ? '0' : '1')}
              hint="Show or hide your profile from the public directory."
            />
          )}

          <div className="sm:col-span-2 pt-1">
            <PrimaryButton type="submit" loading={wait} icon={<Icon.ArrowUp className="h-4 w-4" />}>
              {wait ? 'Please wait…' : 'Upgrade'}
            </PrimaryButton>
          </div>
        </div>
      </FormCard>
    </>
  );
};
